(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reploChunk.0bc63971-a98b-4d74-b5eb-0a53a2626c6b.2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Get all radio inputs for customer type and setup options
  const customerTypeRadios = document.querySelectorAll('[data-customer-type]');
  const setupTypeRadios = document.querySelectorAll('[data-setup-type]');
  
  // Function to update Shopify cart attributes
  function updateCartAttribute(key, value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [key]: value
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attribute updated:', data);
    })
    .catch(error => {
      console.error('Error updating cart attribute:', error);
    });
  }
  
  // Handle customer type change
  customerTypeRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        updateCartAttribute('New-Or-Existing-Customer', this.value);
      }
    });
  });
  
  // Handle setup options change
  setupTypeRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        updateCartAttribute('Radio-Setup', this.value);
        
        // If this is the pre-activation option with a variant ID
        if (this.getAttribute('data-setup-type') === 'pre') {
          const variantId = this.getAttribute('data-variant-id');
          if (variantId) {
            // Here you can implement logic to add the variant to cart or update product options
            console.log('Selected pre-activation with variant ID:', variantId);
          }
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
